var $09a0ddc6d157c4fe$exports = {};
$09a0ddc6d157c4fe$exports = {
    "loading": `\u{141}adowanie...`,
    "loadingMore": `Wczytywanie wi\u{119}kszej liczby...`
};


export {$09a0ddc6d157c4fe$exports as default};
//# sourceMappingURL=pl-PL.module.js.map
